import {
  EcommerceMerchantAction,
  LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT,
  LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT_FAIL,
  LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT_SUCCESS,
  LoadEcommerceMerchantPayoutsAmount,
  LoadEcommerceMerchantPayoutsAmountFail,
  LoadEcommerceMerchantPayoutsAmountSuccess
} from "../actions";

export interface IEcommerceMerchantPayoutsAmountEntityState {
  payoutsAmount?: any,
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceMerchantPayoutsAmountState {
  entities: { [websiteId: number]: IEcommerceMerchantPayoutsAmountEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceMerchantPayoutsAmountState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceMerchantPayoutsAmountState = initialState, action: EcommerceMerchantAction): IEcommerceMerchantPayoutsAmountState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT:
      payload = (<LoadEcommerceMerchantPayoutsAmount>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT_SUCCESS:
      payload = (<LoadEcommerceMerchantPayoutsAmountSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            payoutsAmount: payload.payoutsAmount,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT_FAIL:
      payload = (<LoadEcommerceMerchantPayoutsAmountFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
